import { useGrowthBook } from '@growthbook/growthbook-react';
import { useSelector } from 'react-redux';

import { SORT } from 'dpl/constants/query_params';
import { FEATURES } from 'dpl/shared/constants/features';
import { GB_FEATURES } from 'dpl/shared/constants/gb_features';
import isFeatureEnabled from 'dpl/util/isFeatureEnabled';

import {
  RESULT_SORTS,
  SORT_BEST_MATCH,
  SORT_OPTIONS
} from '../utils/constants';

const IS_REL_SEARCH_RESULTS_SORT = isFeatureEnabled(
  FEATURES.REL_SEARCH_RESULTS_SORT
);

/**
 * exp_search_results_sort (CORE-6547): A/B test of a Sort control on web
 * search results. Control is today's page; the variant gets the Sort button.
 *
 * The flag is checked before the experiment so a buyer is only logged as
 * exposed when they could actually see the button.
 */
export default function useSearchResultsSort() {
  const growthbook = useGrowthBook();
  const sortParam = useSelector(({ queryParams }: any) => queryParams[SORT]);

  const isSortVisible =
    IS_REL_SEARCH_RESULTS_SORT &&
    growthbook?.getFeatureValue(
      GB_FEATURES.EXP_SEARCH_RESULTS_SORT,
      'control'
    ) === 'variant';

  return {
    isSortVisible,
    // An unknown `sort`, including the breeders tab's `location`, is served
    // best match, so it reads as best match here too.
    activeSort: RESULT_SORTS.includes(sortParam) ? sortParam : SORT_BEST_MATCH,
    // The option the buyer picked, best match included. Null until they pick
    // one, so the button can read "Sort" for the untouched default.
    selectedOption:
      SORT_OPTIONS.find(option => option.value === sortParam) ?? null
  };
}
